

// import React, { useState, useEffect } from "react";
// import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
// import Sidebar from "./Recruitment/components/Sidebar";
// import LoginPage from "./Recruitment/components/LoginPage";
// // import HomePage from "./Recruitment/components/Home";
// import LeaveManagement from "./TimeSheetManagement/components/LeaveManagement";
// import JobOpeningForm from "./Recruitment/components/JobOpeningForm";
// import Settings from "./Recruitment/components/Settings";
// import SocialMediaSettings from "./Recruitment/components/SocialMediaSettings";
// import JobListings from "./Recruitment/components/JobListings";
// import JobCreate from "./Recruitment/components/JobCreate";
// import ForgotPassword from "./Recruitment/components/ForgotPassword";
// import ClientCreation from "./Recruitment/components/ClientCreation";
// import ClientListings from "./Recruitment/components/ClientListings";
// import ClientColumn from "./Recruitment/components/ClientColumn";
// import ClientView from "./Recruitment/components/ClientView";
// import AddModal from "./Resume_Submission/Components/AddModal";
// import CreateContact from "./Recruitment/components/ContactCreate";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Contactlisting from "./Recruitment/components/contactlisting";
// import JobEditView from "./Recruitment/components/JobEditView";
// import Jobtemplate from "./Recruitment/components/NewJobTemplate";
// import JobTemplatesPage from "./Recruitment/components/templates";
// import Users from "./Recruitment/components/user_page";
// import ClientEditView from "./Recruitment/components/ClientColumn";
// import ContactEditView from "./Recruitment/components/ContactEditView";
// import Newgroup from "./Recruitment/components/NewGroup";
// import GroupsPage from "./Recruitment/components/groups";

// import RecruitmentDashboard from "./erprecruitment/Components/RecruitmentDashboard";
// import RoleDetailView from "./erprecruitment/Components/RoleDetailView";
// import PerformanceReportPage from "./erprecruitment/Components/PerformanceReportPage";
// import ResumeDashboard from "./Resume_Submission/Components/ResumeDashboard";
// // Import the CandidateDetail component
// import CandidateDetail from "./Resume_Submission/Components/CandidateDetail";
// import UserManagement from "./erprecruitment/Components/UserManagement";
// import BenchSales from "./Bench_Sales/Components/BenchSales";

// import CompaniesView from "./TimeSheetManagement/components/CompaniesView";

// import ManagerTimesheet from "./TimeSheetManagement/components/ManagerTimesheet";
// import TimeSheetApprovals from "./TimeSheetManagement/components/TimeSheetApprovals";
// import UserDetails from "./TimeSheetManagement/components/UserDetails";

// import ExternalSubmission from './Bench_Sales/Components/ExternalSubmission';
// import CompanyDashboard from "./crm/pages/CompanyDashboard";
// import CompanyDetails from "./crm/pages/CompanyDetails";
// import Accounts from "./Accounts/components/useraccounts";
// import Timesheets from "./Accounts/components/Timesheets";
// import JobOpenPortal from "./erprecruitment/Components/JobOpenPortal";
// import JobDetailsPage from "./erprecruitment/Components/JobDetailsPage";
// import CandidateStatusTracker from "./erprecruitment/Components/CandidateStatusTracker";

// // ✅ H1B IMPORTS
// import H1BIntakeForm from "./H1B/components/H1BIntakeForm";
// import CognifyarH1BIntakeForm from "./H1B/components/CognifyarH1BIntakeForm";
// import DisensystemH1BIntakeForm from "./H1B/components/DisensystemH1BIntakeForm";
// import H1BDashboard from "./H1B/components/AdminDashboard";
// import H1BSubmissionDetail from "./H1B/components/SubmissionDetail";

// // ✅ ATS IMPORTS
// import ATS from "./ATS/components/ATS";
// import CandidateForm from "./ATS/components/CandidateForm";
// import CandidateForm2 from "./ATS/components/CandidateForm2";

// // ✅ MSA IMPORTS
// import MSA from "./MSA/components/MSA";

// // ✅ INVOICE IMPORTS
// import InvoiceList from "./Invoice/components/InvoiceList";

// // ✅ DOCUSIGN SIGNING PAGE IMPORTS (NEW!)
// import PublicDocuSignSigning from './MSA/components/PublicDocuSignSigning';
// import DocuSignSigningPage from './MSA/components/DocuSignSigningPage';
// // Reverted: import SigningComplete from './MSA/components/SigningComplete'; 

//  import SubmissionDashboard from "./Submissions/components/SubmissionDashboard";
//  import JobReport from "./Submissions/components/JobReport";

// import Swal from 'sweetalert2';
// import BASE_URL from "./url";
// import "./App.css";

// const App = () => {
//   const [isPinned, setIsPinned] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [isValidating, setIsValidating] = useState(true);
//   const [userRole, setUserRole] = useState(null);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const SESSION_DURATION = 8 * 60 * 60 * 1000; // 8 hours in milliseconds

//   const defaultSwalOptions = {
//     background: '#f8f9fa',
//     color: '#333',
//     confirmButtonColor: '#3085d6',
//     cancelButtonColor: '#d33',
//   };

//   // Validate token with backend
//   const validateToken = async (token) => {
//     try {
//       const response = await fetch(`${BASE_URL}/api/auth/me`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (!response.ok) {
//         throw new Error('Token validation failed');
//       }

//       const data = await response.json();
//       if (data.success && data.role) {
//         setUserRole(data.role);
//         localStorage.setItem("isSupervisor", data.isSupervisor ? "true" : "false");
//       }
//       return data ? true : false;

//     } catch (error) {
//       console.error('Token validation error:', error);
//       return false;
//     }
//   };

//   // Logout function
//   const handleLogout = async (reason = 'manual') => {
//     console.log(`🚪 Logging out - Reason: ${reason}`);
    
//     const sessionId = localStorage.getItem("currentSessionId");
//     const token = localStorage.getItem("token");

//     // Track logout if we have session data
//     if (sessionId && token) {
//       try {
//         await fetch(`${BASE_URL}/api/auth/track-logout`, {
//           method: "POST",
//           headers: { 
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}`
//           },
//           body: JSON.stringify({ trackingId: parseInt(sessionId) })
//         });
//         console.log('✅ Logout tracked successfully');
//       } catch (error) {
//         console.error("Failed to track logout:", error);
//       }
//     }

//     // Clear all session data
//     localStorage.clear();
//     sessionStorage.clear();
    
//     // Update state
//     setIsAuthenticated(false);
//     setUserRole(null);
    
//     // Navigate to login
//     navigate('/', { replace: true });
    
//     // Show appropriate message
//     if (reason === 'session_expired') {
//       toast.error('Your session has expired. Please login again.', {
//         position: "top-center",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true
//       });
//     } else if (reason === 'token_invalid') {
//       toast.error('Your session is no longer valid. Please login again.', {
//         position: "top-center",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true
//       });
//     }
//   };

//   // Check session validity
//   const checkSession = async () => {
//     const token = localStorage.getItem("token");
//     const loginTime = localStorage.getItem("loginTime");
    
//     console.log('🔍 Checking session validity...');

//     if (!token) {
//       console.log('❌ No token found');
//       setIsAuthenticated(false);
//       setUserRole(null);
//       setIsValidating(false);
//       return false;
//     }

//     // Check if session has expired (8 hours)
//     if (loginTime) {
//       const elapsed = Date.now() - parseInt(loginTime);
//       if (elapsed > SESSION_DURATION) {
//         console.log('⏰ Session expired (8 hours)');
//         await handleLogout('session_expired');
//         setIsValidating(false);
//         return false;
//       }
//     }

//     // Validate token with backend
//     const isValid = await validateToken(token);
    
//     if (!isValid) {
//       console.log('❌ Token validation failed');
//       await handleLogout('token_invalid');
//       setIsValidating(false);
//       return false;
//     }

//     console.log('✅ Session is valid');
//     setIsAuthenticated(true);
//     setIsValidating(false);
//     return true;
//   };

//   // Initial session check on mount
//   useEffect(() => {
//     checkSession();
//   }, []);

//   // Check session on every route change
// useEffect(() => {
//     if (location.pathname !== '/' && !location.pathname.includes('/h1b') && !location.pathname.includes('/sign/')) {
//       checkSession();
      
//       // Save intended destination if not authenticated
//       if (!isAuthenticated) {
//         console.log(`📍 Saving redirect path: ${location.pathname}`);
//         localStorage.setItem('redirectPath', location.pathname);
//       }
//     }
//   }, [location.pathname, isAuthenticated]);

//   // Set up session timeout (8 hours)
//   useEffect(() => {
//     if (!isAuthenticated) return;

//     const loginTime = localStorage.getItem("loginTime");
//     if (!loginTime) {
//       localStorage.setItem("loginTime", Date.now().toString());
//     }

//     // Check session every minute
//     const sessionCheckInterval = setInterval(() => {
//       const currentLoginTime = localStorage.getItem("loginTime");
//       if (currentLoginTime) {
//         const elapsed = Date.now() - parseInt(currentLoginTime);
        
//         // If more than 8 hours, logout
//         if (elapsed > SESSION_DURATION) {
//           clearInterval(sessionCheckInterval);
//           handleLogout('session_expired');
//         }
//       }
//     }, 60000); // Check every minute

//     return () => clearInterval(sessionCheckInterval);
//   }, [isAuthenticated]);

//   // Handle page visibility (user switches tabs)
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (!document.hidden && isAuthenticated) {
//         // User came back to the tab - validate session
//         checkSession();
//       }
//     };

//     document.addEventListener('visibilitychange', handleVisibilityChange);
//     return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
//   }, [isAuthenticated]);

//   const togglePinned = () => setIsPinned(!isPinned);

//   const hasRecruitmentAccess = () => {
//     const role = localStorage.getItem('role');
//     return role === 'manager' || role === 'admin' || role === 'super_admin' || role === 'teamlead' || role === 'team_lead';
//   };

//   const isRecruiter = () => {
//     const role = localStorage.getItem('role');
//     return role === 'user' || role === 'recruiter';
//   };

//   const hasH1BAdminAccess = () => {
//     const role = localStorage.getItem('role');
//     return role === 'admin' || role === 'super_admin';
//   };

//   const hasATSAccess = () => {
//     const role = localStorage.getItem('role');
//     return ["admin", "super_admin", "manager", "user", "User", "teamlead", "team_lead", "recruiter"].includes(role);
//   };

//   const isExternalUser = () => {
//     const role = localStorage.getItem('role');
//     return role === 'External user' || role === 'external_user' || role === 'external-user';
//   };

//   // Show loading state while validating with Prophecy branding
//   if (isValidating) {
//     return (
//       <div style={{
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         fontFamily: 'Arial, sans-serif'
//       }}>
//         <div style={{
//           fontSize: '48px',
//           fontWeight: 'bold',
//           color: 'rgb(1, 157, 136)',
//           marginBottom: '30px',
//           letterSpacing: '2px',
//           textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
//         }}>
//           PROPHECY
//         </div>
//         <div style={{
//           width: '60px',
//           height: '60px',
//           border: '6px solid rgba(255, 255, 255, 0.3)',
//           borderTop: '6px solid rgb(1, 157, 136)',
//           borderRadius: '50%',
//           animation: 'spin 1s linear infinite'
//         }}></div>
//         <style>{`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}</style>
//       </div>
//     );
//   }

//   const isCandidateForm2Page = location.pathname === '/ats' && new URLSearchParams(window.location.search).get('candidateForm') === 'true';
//   const isCandidateFormPage = isExternalUser() && (location.pathname === '/careers' || location.pathname === '/');
//   const isJobDetailsPage = location.pathname.startsWith('/job/');
//   const isH1BIntakePage = location.pathname === '/h1b';
//   const isCognifyarH1BIntakePage = location.pathname === '/cognifyar-h1b';
//   const isDisensystemH1BIntakePage = location.pathname === '/disensystem-h1b';
  
//   // ✅ NEW: Check if this is a public signing page (no sidebar needed)
//   const isPublicSigningPage = location.pathname.startsWith('/sign/') || location.pathname.startsWith('/msa/signing/');

//   return (
//     <div className={`app-container ${isAuthenticated || isCandidateForm2Page || isCandidateFormPage || isJobDetailsPage || isH1BIntakePage || isCognifyarH1BIntakePage || isDisensystemH1BIntakePage || isPublicSigningPage ? "" : "login-wrapper"}`}>
//       {isAuthenticated && !isCandidateForm2Page && !isCandidateFormPage && !isJobDetailsPage && !isH1BIntakePage && !isCognifyarH1BIntakePage && !isDisensystemH1BIntakePage && !isPublicSigningPage && <Sidebar isPinned={isPinned} togglePinned={togglePinned} />}
//       <div className={`main-content ${isPinned ? "" : "shifted"}`}>
//         <ToastContainer />
//         <Routes>
//           {/* Authentication Routes */}
//        <Route path="/" element={isAuthenticated ? <Navigate to={new URLSearchParams(window.location.search).get('redirect') || (isExternalUser() ? "/careers" : (localStorage.getItem('role') === 'super_admin' ? "/recruitment-dashboard" : "/timesheets"))} /> : <LoginPage />} />
//           <Route path="/login" element={isAuthenticated ? <Navigate to={new URLSearchParams(window.location.search).get('redirect') || (localStorage.getItem('role') === 'super_admin' ? "/recruitment-dashboard" : "/timesheets")} /> : <LoginPage />} />
//           <Route path="/forgot-password" element={<ForgotPassword />} />
//           <Route path="/forgot" element={<ForgotPassword />} />
           
//           {/* ============================================ */}
//           {/* ✅ PUBLIC SIGNING PAGE - NO LOGIN REQUIRED */}
//           {/* ============================================ */}
//           {/* Used when external recipient clicks email link */}
//           {/* Route: /sign/:signingToken */}
//           <Route 
//             path="/sign/:signingToken" 
//             element={<PublicDocuSignSigning />} 
//           />
          
//           <Route 
//             path="/msa/signing/:signingToken" 
//             element={<PublicDocuSignSigning />} 
//           />


//           {/* ============================================ */}
//           {/* ✅ AUTHENTICATED SIGNING PAGE - LOGIN REQUIRED */}
//           {/* ============================================ */}
//           {/* Used by logged-in users in the app */}
//           {/* Route: /msa/docusign/:signingToken */}
//           <Route 
//             path="/msa/docusign/:signingToken" 
//             element={
//               isAuthenticated && !isExternalUser() 
//                 ? <DocuSignSigningPage /> 
//                 : <Navigate to={`/login?redirect=${location.pathname}`} />
//             } 
//           />

//           {/* ============================================ */}
//           {/* ✅ MSA MODULE - MAIN INTERFACE */}
//           {/* ============================================ */}
//           {/* Main MSA module for authenticated users */}
//           {/* Route: /msa */}
//           <Route 
//             path="/msa" 
//             element={
//               isAuthenticated && !isExternalUser() 
//                 ? <MSA /> 
//                 : <Navigate to={`/login?redirect=${location.pathname}`} />
//             } 
//           />

//           {/* H1B Routes */}
//           <Route 
//             path="/h1b" 
//             element={<H1BIntakeForm />} 
//           />
//           <Route 
//             path="/cognifyar-h1b" 
//             element={<CognifyarH1BIntakeForm />} 
//           />
//           <Route 
//             path="/disensystem-h1b" 
//             element={<DisensystemH1BIntakeForm />} 
//           />

//           <Route 
//             path="/h1b/dashboard" 
//             element={isAuthenticated && hasH1BAdminAccess() ? <H1BDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           <Route 
//             path="/h1b/submissions/:id" 
//             element={isAuthenticated && hasH1BAdminAccess() ? <H1BSubmissionDetail /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Jobs Portal */}
//           <Route 
//             path="/careers" 
//             element={
//               isExternalUser() 
//                 ? <CandidateForm /> 
//                 : isAuthenticated && !isExternalUser()
//                   ? <Navigate to="/dashboard" /> 
//                   : <JobOpenPortal />
//             }
//           />

//           <Route 
//             path="/job/:jobId" 
//             element={<JobDetailsPage />} 
//           />

//           {/* ATS Routes */}
//           <Route 
//             path="/ats" 
//             element={
//               new URLSearchParams(window.location.search).get('candidateForm') === 'true' 
//                 ? <CandidateForm2 /> 
//                 : isAuthenticated && hasATSAccess() 
//                   ? <ATS /> 
//                   : <Navigate to={`/login?redirect=${location.pathname}`} />
//             } 
//           />

//           {/* Main Routes */}
//           <Route 
//             path="/dashboard" 
//             element={
//                 isAuthenticated && !isExternalUser()
//                 ? <Navigate to={localStorage.getItem('role') === 'super_admin' ? "/recruitment-dashboard" : "/timesheets"} />
//                 : <Navigate to={isAuthenticated ? "/track-status" : `/login?redirect=${location.pathname}`} />
//             } 
//           />

//           <Route 
//             path="/accounts" 
//             element={
//               isAuthenticated && !isExternalUser() 
//                 ? <Accounts /> 
//                 : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />
//             } 
//           />

//           <Route 
//             path="/invoices" 
//             element={
//               isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || localStorage.getItem('role') === 'account_manager' || localStorage.getItem('role') === 'account-manager' || hasCustomPermission('invoices')) && !isExternalUser() 
//                 ? <InvoiceList /> 
//                 : <Navigate to={`/login?redirect=${location.pathname}`} />
//             } 
//           />
        
//           {/* Recruitment Dashboard */}
//           <Route 
//             path="/recruitment-dashboard" 
//             element={isAuthenticated && hasRecruitmentAccess() && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />


//           <Route 
//             path="/performance-report" 
//             element={isAuthenticated && hasRecruitmentAccess() && !isExternalUser() ? <PerformanceReportPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           <Route 
//             path="/role-detail/:roleId" 
//             element={isAuthenticated && (hasRecruitmentAccess() || isRecruiter()) && !isExternalUser() ? <RoleDetailView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           <Route 
//             path="/teamlead-dashboard" 
//             element={isAuthenticated && (localStorage.getItem('role') === 'teamlead' || localStorage.getItem('role') === 'team_lead' || hasCustomPermission('recruitment_dashboard')) && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           <Route 
//             path="/recruiter-view" 
//             element={isAuthenticated && isRecruiter() && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           <Route 
//             path="/admin-dashboard" 
//             element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin') && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Job Management Routes */}
// // <Route path="/job-openings" element={isAuthenticated && !isExternalUser() ? <JobOpeningForm /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/job-create" element={isAuthenticated && !isExternalUser() ? <JobCreate /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/job-listings" element={isAuthenticated && !isExternalUser() ? <JobListings /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/job-view" element={isAuthenticated && !isExternalUser() ? <JobEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

//           {/* Client Management Routes */}
// // <Route path="/client-creation" element={isAuthenticated && !isExternalUser() ? <ClientCreation /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/Client-listings" element={isAuthenticated && !isExternalUser() ? <ClientListings /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/client-column" element={isAuthenticated && !isExternalUser() ? <ClientColumn /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/client-view" element={isAuthenticated && !isExternalUser() ? <ClientEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

//           {/* Contact Management Routes */}
// // <Route path="/create-contact" element={isAuthenticated && !isExternalUser() ? <CreateContact /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/Contactlisting" element={isAuthenticated && !isExternalUser() ? <Contactlisting /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/Contact-View" element={isAuthenticated && !isExternalUser() ? <ContactEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

//           {/* Template and User Routes */}
// // <Route path="/jobtemplate" element={isAuthenticated && !isExternalUser() ? <Jobtemplate /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/template" element={isAuthenticated && !isExternalUser() ? <JobTemplatesPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/Users" element={isAuthenticated && !isExternalUser() ? <Users /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

//           {/* ============================================ */}
//           {/* ✅ RESUME DASHBOARD AND CANDIDATE DETAIL ROUTES */}
//           {/* ============================================ */}
//           {/* Main Resume Dashboard */}
//           <Route 
//             path="/resume-dashboard" 
//             element={isAuthenticated && !isExternalUser() ? <ResumeDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Candidate Detail Page */}
//           <Route 
//             path="/candidates/:id" 
//             element={isAuthenticated && !isExternalUser() ? <CandidateDetail /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Edit Candidate Page - Optional (if you want a separate edit page) */}
//           <Route 
//             path="/candidates/edit/:id" 
//             element={isAuthenticated && !isExternalUser() ? <AddModal /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* User Management - Admin Only */}
//           <Route 
//             path="/user-management" 
//             element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || hasCustomPermission('user_management')) && !isExternalUser() ? <UserManagement /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Bench Sales Routes */}
//           <Route path="/bench-sales" element={isAuthenticated && !isExternalUser() ? <BenchSales /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-sales-dashboard" element={isAuthenticated && !isExternalUser() ? <BenchSales view="dashboard" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-sales-recruiter" element={isAuthenticated && !isExternalUser() ? <BenchSales view="recruiter" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-candidates" element={isAuthenticated && !isExternalUser() ? <BenchSales view="candidates" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-requirements" element={isAuthenticated && !isExternalUser() ? <BenchSales view="requirements" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-submissions" element={isAuthenticated && !isExternalUser() ? <BenchSales view="submissions" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-marketing" element={isAuthenticated && !isExternalUser() ? <BenchSales view="marketing" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-analytics" element={isAuthenticated && !isExternalUser() ? <BenchSales view="analytics" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-vendors" element={isAuthenticated && !isExternalUser() ? <BenchSales view="vendors" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-hotlist" element={isAuthenticated && !isExternalUser() ? <BenchSales view="hotlist" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/bench-external-submission" element={isAuthenticated && !isExternalUser() ? <ExternalSubmission /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/timesheets" element={isAuthenticated && !isExternalUser() ? <Timesheets /> : <Navigate to={isAuthenticated ? "/track-status" : `/login?redirect=${location.pathname}`} />} />
//           <Route path="/submissions" element={isAuthenticated && !isExternalUser() ? <SubmissionDashboard /> : <Navigate to="/" />} /> 
//           <Route path="/job-report" element={isAuthenticated && !isExternalUser() ? <JobReport /> : <Navigate to="/" />} />
//           <Route path="/submissions/:roleId" element={isAuthenticated && !isExternalUser() ? <RoleDetailView /> : <Navigate to="/" />} /> 

//           {/* Time Sheet Management Routes */}
//           <Route path="/companies" element={isAuthenticated && !isExternalUser() ? <CompaniesView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/manager-timesheet" element={isAuthenticated && !isExternalUser() ? <ManagerTimesheet /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           <Route path="/timesheet-approvals" element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || localStorage.getItem('role') === 'manager' || localStorage.getItem('role') === 'teamlead' || localStorage.getItem('role') === 'team_lead' || localStorage.getItem('isSupervisor') === 'true') && !isExternalUser() ? <TimeSheetApprovals /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

//           <Route path="/user-details/:employeeId" element={isAuthenticated && !isExternalUser() ? <UserDetails/> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// <Route path="/leave-manage" element={isAuthenticated && !isExternalUser() ? <LeaveManagement /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
//           {/* Groups Routes */}
// // <Route path="/Newgroup" element={isAuthenticated && !isExternalUser() ? <Newgroup /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
// // <Route path="/Group" element={isAuthenticated && !isExternalUser() ? <GroupsPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          
//           {/* Settings Route */}
//           <Route 
//             path="/settings" 
//             element={isAuthenticated && !isExternalUser() ? <Settings /> : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />} 
//           />

//           {/* Social Media Settings Route */}
//           <Route 
//             path="/recruitment/social-settings" 
//             element={isAuthenticated && !isExternalUser() ? <SocialMediaSettings /> : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />} 
//           />
          
//           {/* Catch-all route */}
//                <Route path="*" element={<Navigate to={isAuthenticated ? (isExternalUser() ? "/careers" : (localStorage.getItem('role') === 'super_admin' ? "/recruitment-dashboard" : "/timesheets")) : `/login?redirect=${location.pathname}`} />} />
//         </Routes>
//       </div>
//     </div>
//   );
// };

// export default App;



import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "./Recruitment/components/Sidebar";
import LoginPage from "./Recruitment/components/LoginPage";
// import HomePage from "./Recruitment/components/Home";
import LeaveManagement from "./TimeSheetManagement/components/LeaveManagement";
import JobOpeningForm from "./Recruitment/components/JobOpeningForm";
import Settings from "./Recruitment/components/Settings";
import SocialMediaSettings from "./Recruitment/components/SocialMediaSettings";
import JobListings from "./Recruitment/components/JobListings";
import JobCreate from "./Recruitment/components/JobCreate";
import ForgotPassword from "./Recruitment/components/ForgotPassword";
import ClientCreation from "./Recruitment/components/ClientCreation";
import ClientListings from "./Recruitment/components/ClientListings";
import ClientColumn from "./Recruitment/components/ClientColumn";
import ClientView from "./Recruitment/components/ClientView";
import AddModal from "./Resume_Submission/Components/AddModal";
import CreateContact from "./Recruitment/components/ContactCreate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Contactlisting from "./Recruitment/components/contactlisting";
import JobEditView from "./Recruitment/components/JobEditView";
import Jobtemplate from "./Recruitment/components/NewJobTemplate";
import JobTemplatesPage from "./Recruitment/components/templates";
import Users from "./Recruitment/components/user_page";
import ClientEditView from "./Recruitment/components/ClientColumn";
import ContactEditView from "./Recruitment/components/ContactEditView";
import Newgroup from "./Recruitment/components/NewGroup";
import GroupsPage from "./Recruitment/components/groups";

import RecruitmentDashboard from "./erprecruitment/Components/RecruitmentDashboard";
import RoleDetailView from "./erprecruitment/Components/RoleDetailView";
import PerformanceReportPage from "./erprecruitment/Components/PerformanceReportPage";
import BenchHeatReportPage from "./erprecruitment/Components/BenchHeatReportPage";
import ResumeDashboard from "./Resume_Submission/Components/ResumeDashboard";
// Import the CandidateDetail component
import CandidateDetail from "./Resume_Submission/Components/CandidateDetail";
import JoinOurBench from "./Resume_Submission/Components/JoinOurBench";
import UserManagement from "./erprecruitment/Components/UserManagement";
import BenchSales from "./Bench_Sales/Components/BenchSales";
import { BenchDashboard } from "./Bench_Manage/Components/BenchDashboard";
import { BenchReport } from "./Bench_Manage/Components/BenchReport";
import { BenchSubmissionDashboard } from "./Bench_Manage/Components/BenchSubmissionDashboard";

import CompaniesView from "./TimeSheetManagement/components/CompaniesView";

import ManagerTimesheet from "./TimeSheetManagement/components/ManagerTimesheet";
import TimeSheetApprovals from "./TimeSheetManagement/components/TimeSheetApprovals";
import UserDetails from "./TimeSheetManagement/components/UserDetails";

import ExternalSubmission from './Bench_Sales/Components/ExternalSubmission';
import CompanyDashboard from "./crm/pages/CompanyDashboard";
import CompanyDetails from "./crm/pages/CompanyDetails";
import SupplierPortal from "./crm/pages/SupplierPortal";
import PortalLogin from "./crm/portal/PortalLogin";
import PortalDashboard from "./crm/portal/PortalDashboard";
import PortalDocumentViewer from "./crm/portal/PortalDocumentViewer";
import PortalCompanyOverview from "./crm/portal/PortalCompanyOverview";
import MsaPoEntitySelection from "./crm/pages/MsaPoEntitySelection";
import MsaPoDashboard from "./crm/pages/MsaPoDashboard";
import Accounts from "./Accounts/components/useraccounts";
import Timesheets from "./Accounts/components/Timesheets";
import JobOpenPortal from "./erprecruitment/Components/JobOpenPortal";
import JobDetailsPage from "./erprecruitment/Components/JobDetailsPage";
import CandidateStatusTracker from "./erprecruitment/Components/CandidateStatusTracker";

// ✅ H1B IMPORTS
import H1BIntakeForm from "./H1B/components/H1BIntakeForm";
import CognifyarH1BIntakeForm from "./H1B/components/CognifyarH1BIntakeForm";
import DisensystemH1BIntakeForm from "./H1B/components/DisensystemH1BIntakeForm";
import H1BDashboard from "./H1B/components/AdminDashboard";
import H1BSubmissionDetail from "./H1B/components/SubmissionDetail";

// ✅ ATS IMPORTS
import ATS from "./ATS/components/ATS";
import CandidateForm from "./ATS/components/CandidateForm";
import CandidateForm2 from "./ATS/components/CandidateForm2";

// ✅ MSA IMPORTS
import MSA from "./MSA/components/MSA";

// ✅ INVOICE IMPORTS
import InvoiceList from "./Invoice/components/InvoiceList";

// ✅ DOCUSIGN SIGNING PAGE IMPORTS (NEW!)
import PublicDocuSignSigning from './MSA/components/PublicDocuSignSigning';
import DocuSignSigningPage from './MSA/components/DocuSignSigningPage';
// Reverted: import SigningComplete from './MSA/components/SigningComplete'; 

 import SubmissionDashboard from "./Submissions/components/SubmissionDashboard";
 import JobReport from "./Submissions/components/JobReport";
 import JobCountReport from "./Submissions/components/JobCountReport";
 import ClientCountReport from "./Submissions/components/ClientCountReport";
 import OnboardingQueue from "./crm/pages/OnboardingQueue";
 import OnboardingReport from "./crm/pages/OnboardingReport";
 import DeploymentReport from "./crm/pages/DeploymentReport";
 import ERPDemoPage from "./demo/ERPDemoPage";

import Swal from 'sweetalert2';
import BASE_URL from "./url";
import "./App.css";

const App = () => {
  const [isPinned, setIsPinned] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isValidating, setIsValidating] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const SESSION_DURATION = 8 * 60 * 60 * 1000; // 8 hours in milliseconds

  const defaultSwalOptions = {
    background: '#f8f9fa',
    color: '#333',
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
  };

  // Validate token with backend
  const validateToken = async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/api/auth/me`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Token validation failed');
      }

      const data = await response.json();
      if (data && (data.success || data.id) && data.role) {
        setUserRole(data.role);
        localStorage.setItem("isSupervisor", data.isSupervisor ? "true" : "false");
        if (data.candidateCode) localStorage.setItem("candidateCode", data.candidateCode);
        if (data.candidateId) localStorage.setItem("candidateId", data.candidateId.toString());
        if (data.username) localStorage.setItem("username", data.username);
        if (data.email) localStorage.setItem("email", data.email);
        localStorage.setItem("user", JSON.stringify(data));
      }
      return data ? true : false;

    } catch (error) {
      console.error('Token validation error:', error);
      return false;
    }
  };

  // Logout function
  const handleLogout = async (reason = 'manual') => {
    console.log(`🚪 Logging out - Reason: ${reason}`);
    
    const sessionId = localStorage.getItem("currentSessionId");
    const token = localStorage.getItem("token");

    // Track logout if we have session data
    if (sessionId && token) {
      try {
        await fetch(`${BASE_URL}/api/auth/track-logout`, {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ trackingId: parseInt(sessionId) })
        });
        console.log('✅ Logout tracked successfully');
      } catch (error) {
        console.error("Failed to track logout:", error);
      }
    }

    // Clear all session data
    localStorage.clear();
    sessionStorage.clear();
    
    // Update state
    setIsAuthenticated(false);
    setUserRole(null);
    
    // Navigate to login
    navigate('/', { replace: true });
    
    // Show appropriate message
    if (reason === 'session_expired') {
      toast.error('Your session has expired. Please login again.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    } else if (reason === 'token_invalid') {
      toast.error('Your session is no longer valid. Please login again.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
      });
    }
  };

  // Check session validity
  const checkSession = async () => {
    const token = localStorage.getItem("token");
    const loginTime = localStorage.getItem("loginTime");
    
    console.log('🔍 Checking session validity...');

    if (!token) {
      console.log('❌ No token found');
      setIsAuthenticated(false);
      setUserRole(null);
      setIsValidating(false);
      return false;
    }

    // Check if session has expired (8 hours)
    if (loginTime) {
      const elapsed = Date.now() - parseInt(loginTime);
      if (elapsed > SESSION_DURATION) {
        console.log('⏰ Session expired (8 hours)');
        await handleLogout('session_expired');
        setIsValidating(false);
        return false;
      }
    }

    // Validate token with backend
    const isValid = await validateToken(token);
    
    if (!isValid) {
      console.log('❌ Token validation failed');
      await handleLogout('token_invalid');
      setIsValidating(false);
      return false;
    }

    console.log('✅ Session is valid');
    setIsAuthenticated(true);
    setIsValidating(false);
    return true;
  };

  // Initial session check on mount
  useEffect(() => {
    checkSession();
  }, []);

  // Check session on every route change
useEffect(() => {
    if (location.pathname !== '/' && !location.pathname.includes('/h1b') && !location.pathname.includes('/sign/') && !location.pathname.includes('/join-our-bench') && !location.pathname.includes('/join-bench')) {
      checkSession();
      
      // Save intended destination if not authenticated
      if (!isAuthenticated) {
        console.log(`📍 Saving redirect path: ${location.pathname}`);
        localStorage.setItem('redirectPath', location.pathname);
      }
    }
  }, [location.pathname, isAuthenticated]);

  // Set up session timeout (8 hours)
  useEffect(() => {
    if (!isAuthenticated) return;

    const loginTime = localStorage.getItem("loginTime");
    if (!loginTime) {
      localStorage.setItem("loginTime", Date.now().toString());
    }

    // Check session every minute
    const sessionCheckInterval = setInterval(() => {
      const currentLoginTime = localStorage.getItem("loginTime");
      if (currentLoginTime) {
        const elapsed = Date.now() - parseInt(currentLoginTime);
        
        // If more than 8 hours, logout
        if (elapsed > SESSION_DURATION) {
          clearInterval(sessionCheckInterval);
          handleLogout('session_expired');
        }
      }
    }, 60000); // Check every minute

    return () => clearInterval(sessionCheckInterval);
  }, [isAuthenticated]);

  // Handle page visibility (user switches tabs)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden && isAuthenticated) {
        // User came back to the tab - validate session
        checkSession();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [isAuthenticated]);

  const togglePinned = () => setIsPinned(!isPinned);

  // Helper: check if current user has a specific permission key granted via Configure Menu Access (user-level first, then role)
  const hasCustomPermission = (permKey) => {
    try {
      // 1. Check individual user-specific permissions
      const userSaved = localStorage.getItem('erp_user_menu_permissions');
      if (userSaved) {
        const userPerms = JSON.parse(userSaved);
        if (Array.isArray(userPerms) && userPerms.includes(permKey)) return true;
      }
      // 2. Fall back to role permissions
      const role = (localStorage.getItem('role') || '').toLowerCase().trim();
      const saved = localStorage.getItem('erp_role_menu_permissions');
      if (!saved) return false;
      const permsMap = JSON.parse(saved);
      const matchedKey = Object.keys(permsMap).find(k => k.toLowerCase().trim() === role);
      if (!matchedKey) return false;
      const perms = permsMap[matchedKey];
      return Array.isArray(perms) && perms.includes(permKey);
    } catch (e) {
      return false;
    }
  };

  const hasRecruitmentAccess = () => {
    const role = localStorage.getItem('role');
    return role === 'manager' || role === 'admin' || role === 'super_admin' || role === 'teamlead' || role === 'team_lead'
      || hasCustomPermission('recruitment_dashboard');
  };

  const isRecruiter = () => {
    const role = localStorage.getItem('role');
    return role === 'user' || role === 'recruiter' || hasCustomPermission('recruitment_dashboard');
  };

  const hasH1BAdminAccess = () => {
    const role = localStorage.getItem('role');
    return role === 'admin' || role === 'super_admin' || hasCustomPermission('h1b');
  };

  const hasATSAccess = () => {
    const role = localStorage.getItem('role');
    return ["admin", "super_admin", "manager", "user", "User", "teamlead", "team_lead", "recruiter"].includes(role)
      || hasCustomPermission('ats');
  };

  const isExternalUser = () => {
    const role = (localStorage.getItem('role') || '').toLowerCase().trim();
    return role === 'external user' || role === 'external_user' || role === 'external-user' || role === 'candidate';
  };

  // Show loading state while validating with Prophecy branding
  if (isValidating) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{
          fontSize: '48px',
          fontWeight: 'bold',
          color: 'rgb(1, 157, 136)',
          marginBottom: '30px',
          letterSpacing: '2px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          PROPHECY
        </div>
        <div style={{
          width: '60px',
          height: '60px',
          border: '6px solid rgba(255, 255, 255, 0.3)',
          borderTop: '6px solid rgb(1, 157, 136)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  const isCandidateForm2Page = location.pathname === '/ats' && new URLSearchParams(window.location.search).get('candidateForm') === 'true';
const isCandidateFormPage = isExternalUser() && (location.pathname.toLowerCase() === '/careers' || location.pathname === '/');
  const isJobDetailsPage = location.pathname.startsWith('/job/');
  const isH1BIntakePage = location.pathname === '/h1b';
  const isCognifyarH1BIntakePage = location.pathname === '/cognifyar-h1b';
  const isDisensystemH1BIntakePage = location.pathname === '/disensystem-h1b';
  
  // ✅ NEW: Check if this is a public signing page (no sidebar needed)
  const isPublicSigningPage = location.pathname.startsWith('/sign/') || location.pathname.startsWith('/msa/signing/');
  const isCandidateStatusPage = location.pathname.startsWith('/track-status') || location.pathname === '/profile';
  const hideSidebarForCandidateStatus = isCandidateStatusPage && (!isAuthenticated || isExternalUser());
  const isJoinOurBenchPage = location.pathname === '/join-our-bench' || location.pathname === '/join-bench';
  const isPortalPage = location.pathname.startsWith('/portal') || location.pathname.startsWith('/supplier-portal');
  const isDemoPage = location.pathname.toLowerCase() === '/demo' || location.pathname.toLowerCase().startsWith('/demo');

  const getDefaultHomeRoute = () => {
    if (isExternalUser()) return "/track-status";
    const role = (localStorage.getItem('role') || '').toLowerCase().trim();
    if (role === 'super_admin') return "/recruitment-dashboard";
    if ((role === 'admin' || role === 'super_admin') && localStorage.getItem('erp_timesheet_required') === 'false') {
      return "/leave-manage";
    }
    return "/timesheets";
  };

  return (
   <div className={`app-container ${isAuthenticated || isCandidateForm2Page || isCandidateFormPage || isJobDetailsPage || isH1BIntakePage || isCognifyarH1BIntakePage || isDisensystemH1BIntakePage || isPublicSigningPage || isCandidateStatusPage || isJoinOurBenchPage || isPortalPage || isDemoPage || location.pathname === '/careers' ? "" : "login-wrapper"}`}>
      {isAuthenticated && !isExternalUser() && location.pathname !== '/careers' && !isDemoPage && !hideSidebarForCandidateStatus && !isCandidateForm2Page && !isCandidateFormPage && !isJobDetailsPage && !isH1BIntakePage && !isCognifyarH1BIntakePage && !isDisensystemH1BIntakePage && !isPublicSigningPage && !isJoinOurBenchPage && !isPortalPage && <Sidebar isPinned={isPinned} togglePinned={togglePinned} />}
      <div className={`main-content ${isExternalUser() || location.pathname === '/careers' || isDemoPage || hideSidebarForCandidateStatus || isJoinOurBenchPage || isPortalPage || !isPinned ? "" : "shifted"}`}>
        <ToastContainer />
        <Routes>
          {/* Public ERP Interactive Demo Page */}
          <Route path="/demo" element={<ERPDemoPage />} />

          {/* Public Join Our Bench Page */}
          <Route path="/join-our-bench" element={<JoinOurBench />} />
          <Route path="/join-bench" element={<Navigate to="/join-our-bench" replace />} />

          {/* Candidate Status Tracking / Profile Page */}
          <Route path="/profile" element={isAuthenticated ? <CandidateStatusTracker isEmbedded={true} /> : <Navigate to="/login" />} />
          <Route path="/track-status" element={<CandidateStatusTracker isEmbedded={isAuthenticated && !isExternalUser()} />} />
          <Route path="/track-status/:candidateCode" element={<CandidateStatusTracker isEmbedded={isAuthenticated && !isExternalUser()} />} />

          {/* Authentication Routes */}
          <Route path="/" element={isAuthenticated ? <Navigate to={new URLSearchParams(window.location.search).get('redirect') || getDefaultHomeRoute()} /> : <LoginPage />} />
          <Route path="/login" element={isAuthenticated ? <Navigate to={new URLSearchParams(window.location.search).get('redirect') || getDefaultHomeRoute()} /> : <LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/forgot" element={<ForgotPassword />} />
           
          {/* ============================================ */}
          {/* ✅ PUBLIC SIGNING PAGE - NO LOGIN REQUIRED */}
          {/* ============================================ */}
          {/* Used when external recipient clicks email link */}
          {/* Route: /sign/:signingToken */}
          <Route 
            path="/sign/:signingToken" 
            element={<PublicDocuSignSigning />} 
          />
          
          <Route 
            path="/msa/signing/:signingToken" 
            element={<PublicDocuSignSigning />} 
          />


          {/* ============================================ */}
          {/* ✅ AUTHENTICATED SIGNING PAGE - LOGIN REQUIRED */}
          {/* ============================================ */}
          {/* Used by logged-in users in the app */}
          {/* Route: /msa/docusign/:signingToken */}
          <Route 
            path="/msa/docusign/:signingToken" 
            element={
              isAuthenticated && !isExternalUser() 
                ? <DocuSignSigningPage /> 
                : <Navigate to={`/login?redirect=${location.pathname}`} />
            } 
          />

          {/* ============================================ */}
          {/* ✅ MSA MODULE - MAIN INTERFACE */}
          {/* ============================================ */}
          {/* Main MSA module for authenticated users */}
          {/* Route: /msa */}
          <Route 
            path="/msa" 
            element={
              isAuthenticated && !isExternalUser() 
                ? <MSA /> 
                : <Navigate to={`/login?redirect=${location.pathname}`} />
            } 
          />

          {/* H1B Routes */}
          <Route 
            path="/h1b" 
            element={<H1BIntakeForm />} 
          />
          <Route 
            path="/cognifyar-h1b" 
            element={<CognifyarH1BIntakeForm />} 
          />
          <Route 
            path="/disensystem-h1b" 
            element={<DisensystemH1BIntakeForm />} 
          />

          <Route 
            path="/h1b/dashboard" 
            element={isAuthenticated && hasH1BAdminAccess() ? <H1BDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/h1b/submissions/:id" 
            element={isAuthenticated && hasH1BAdminAccess() ? <H1BSubmissionDetail /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* Jobs Portal */}
          <Route 
            path="/careers" 
            element={
              isExternalUser() 
                ? <CandidateForm /> 
                : <JobOpenPortal />
            }
          />

          <Route 
            path="/job/:jobId" 
            element={<JobDetailsPage />} 
          />

          {/* ATS Routes */}
          <Route 
            path="/ats" 
            element={
              new URLSearchParams(window.location.search).get('candidateForm') === 'true' 
                ? <CandidateForm2 /> 
                : isAuthenticated && hasATSAccess() 
                  ? <ATS /> 
                  : <Navigate to={`/login?redirect=${location.pathname}`} />
            } 
          />

          {/* Main Routes */}
          <Route 
            path="/dashboard" 
            element={
                isAuthenticated && !isExternalUser()
                ? <Navigate to={getDefaultHomeRoute()} />
                : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />
            } 
          />

          <Route 
            path="/accounts" 
            element={
              isAuthenticated && !isExternalUser() 
                ? <Accounts /> 
                : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />
            } 
          />

          <Route 
            path="/invoices" 
            element={
              isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || localStorage.getItem('role') === 'account_manager' || localStorage.getItem('role') === 'account-manager' || hasCustomPermission('invoices')) && !isExternalUser() 
                ? <InvoiceList /> 
                : <Navigate to={`/login?redirect=${location.pathname}`} />
            } 
          />
        
          {/* Recruitment Dashboard */}
          <Route 
            path="/recruitment-dashboard" 
            element={isAuthenticated && hasRecruitmentAccess() && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />


          <Route 
            path="/performance-report" 
            element={isAuthenticated && !isExternalUser() ? <PerformanceReportPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/bench-heat-report" 
            element={isAuthenticated && !isExternalUser() ? <BenchHeatReportPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/role-detail/:roleId" 
            element={isAuthenticated && (hasRecruitmentAccess() || isRecruiter()) && !isExternalUser() ? <RoleDetailView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/teamlead-dashboard" 
            element={isAuthenticated && (localStorage.getItem('role') === 'teamlead' || localStorage.getItem('role') === 'team_lead' || hasCustomPermission('recruitment_dashboard')) && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/recruiter-view" 
            element={isAuthenticated && isRecruiter() && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          <Route 
            path="/admin-dashboard" 
            element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin') && !isExternalUser() ? <RecruitmentDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* Job Management Routes */}
          <Route path="/job-openings" element={isAuthenticated && !isExternalUser() ? <JobOpeningForm /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/job-create" element={isAuthenticated && !isExternalUser() ? <JobCreate /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/job-listings" element={isAuthenticated && !isExternalUser() ? <JobListings /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/job-view" element={isAuthenticated && !isExternalUser() ? <JobEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

          {/* Client Management Routes */}
          <Route path="/crm/companies" element={isAuthenticated && !isExternalUser() ? <CompanyDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/crm/companies/:id" element={isAuthenticated && !isExternalUser() ? <CompanyDetails /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/crm/msa-po" element={isAuthenticated && !isExternalUser() ? <MsaPoEntitySelection /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/crm/msa-po/:entityId" element={isAuthenticated && !isExternalUser() ? <MsaPoDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/client-creation" element={isAuthenticated && !isExternalUser() ? <ClientCreation /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/Client-listings" element={isAuthenticated && !isExternalUser() ? <ClientListings /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/client-column" element={isAuthenticated && !isExternalUser() ? <ClientColumn /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/client-view" element={isAuthenticated && !isExternalUser() ? <ClientEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

          {/* Contact Management Routes */}
          <Route path="/create-contact" element={isAuthenticated && !isExternalUser() ? <CreateContact /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/Contactlisting" element={isAuthenticated && !isExternalUser() ? <Contactlisting /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/Contact-View" element={isAuthenticated && !isExternalUser() ? <ContactEditView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

          {/* Template and User Routes */}
          <Route path="/jobtemplate" element={isAuthenticated && !isExternalUser() ? <Jobtemplate /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/template" element={isAuthenticated && !isExternalUser() ? <JobTemplatesPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/Users" element={isAuthenticated && !isExternalUser() ? <Users /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

          {/* ============================================ */}
          {/* ✅ RESUME DASHBOARD AND CANDIDATE DETAIL ROUTES */}
          {/* ============================================ */}
          {/* Main Resume Dashboard */}
          <Route 
            path="/resume-dashboard" 
            element={isAuthenticated && !isExternalUser() ? <ResumeDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* Candidate Detail Page */}
          <Route 
            path="/candidates/:id" 
            element={isAuthenticated && !isExternalUser() ? <CandidateDetail /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />
          <Route 
            path="/candidate-detail/:id" 
            element={isAuthenticated && !isExternalUser() ? <CandidateDetail /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* Edit Candidate Page - Optional (if you want a separate edit page) */}
          <Route 
            path="/candidates/edit/:id" 
            element={isAuthenticated && !isExternalUser() ? <AddModal /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* User Management - Admin Only */}
          <Route 
            path="/user-management" 
            element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || hasCustomPermission('user_management')) && !isExternalUser() ? <UserManagement /> : <Navigate to={`/login?redirect=${location.pathname}`} />} 
          />

          {/* Bench Sales Routes */}
          <Route path="/bench-manage/candidates" element={isAuthenticated && !isExternalUser() ? <Navigate to="/resume-dashboard?view=bench" replace /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
           <Route path="/bench-manage/dashboard" element={isAuthenticated && !isExternalUser() ? <BenchDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} /> 
           <Route path="/bench-manage/submissions" element={isAuthenticated && !isExternalUser() ? <BenchSubmissionDashboard /> : <Navigate to={`/login?redirect=${location.pathname}`} />} /> 
           <Route path="/bench-manage/reports" element={isAuthenticated && !isExternalUser() ? <BenchReport /> : <Navigate to={`/login?redirect=${location.pathname}`} />} /> 
          
          <Route path="/bench-sales" element={isAuthenticated && !isExternalUser() ? <BenchSales /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-sales-dashboard" element={isAuthenticated && !isExternalUser() ? <BenchSales view="dashboard" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-sales-recruiter" element={isAuthenticated && !isExternalUser() ? <BenchSales view="recruiter" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-candidates" element={isAuthenticated && !isExternalUser() ? <BenchSales view="candidates" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-requirements" element={isAuthenticated && !isExternalUser() ? <BenchSales view="requirements" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-submissions" element={isAuthenticated && !isExternalUser() ? <BenchSales view="submissions" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-marketing" element={isAuthenticated && !isExternalUser() ? <BenchSales view="marketing" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-analytics" element={isAuthenticated && !isExternalUser() ? <BenchSales view="analytics" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-vendors" element={isAuthenticated && !isExternalUser() ? <BenchSales view="vendors" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-hotlist" element={isAuthenticated && !isExternalUser() ? <BenchSales view="hotlist" /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/bench-external-submission" element={isAuthenticated && !isExternalUser() ? <ExternalSubmission /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/timesheets" element={isAuthenticated && !isExternalUser() ? <Timesheets /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/submissions" element={isAuthenticated && !isExternalUser() ? <SubmissionDashboard /> : <Navigate to="/" />} /> 
          <Route path="/job-report" element={isAuthenticated && !isExternalUser() ? <JobReport /> : <Navigate to="/" />} />
          <Route path="/job-count-report" element={isAuthenticated && !isExternalUser() ? <JobCountReport /> : <Navigate to="/" />} />
          <Route path="/client-count" element={isAuthenticated && !isExternalUser() ? <ClientCountReport /> : <Navigate to="/" />} />
          <Route path="/submissions/:roleId" element={isAuthenticated && !isExternalUser() ? <RoleDetailView /> : <Navigate to="/" />} /> 
<Route 
  path="/onboarding" 
  element={isAuthenticated && !isExternalUser() ? <OnboardingQueue /> : <Navigate to="/" />} 
/>
<Route 
  path="/onboarding-report" 
  element={isAuthenticated && !isExternalUser() ? <OnboardingReport /> : <Navigate to="/" />} 
/>
<Route 
  path="/deployment-report" 
  element={isAuthenticated && !isExternalUser() ? <DeploymentReport /> : <Navigate to="/" />} 
/>
          {/* Time Sheet Management Routes */}
          <Route path="/companies" element={isAuthenticated && !isExternalUser() ? <CompaniesView /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/manager-timesheet" element={isAuthenticated && !isExternalUser() ? <ManagerTimesheet /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/timesheet-approvals" element={isAuthenticated && (localStorage.getItem('role') === 'admin' || localStorage.getItem('role') === 'super_admin' || localStorage.getItem('role') === 'manager' || localStorage.getItem('role') === 'teamlead' || localStorage.getItem('role') === 'team_lead' || localStorage.getItem('isSupervisor') === 'true' || hasCustomPermission('timesheet_approvals')) && !isExternalUser() ? <TimeSheetApprovals /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />

          <Route path="/user-details/:employeeId" element={isAuthenticated && !isExternalUser() ? <UserDetails/> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
<Route path="/leave-manage" element={isAuthenticated && !isExternalUser() ? <LeaveManagement /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          {/* Groups Routes */}
          <Route path="/Newgroup" element={isAuthenticated && !isExternalUser() ? <Newgroup /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          <Route path="/Group" element={isAuthenticated && !isExternalUser() ? <GroupsPage /> : <Navigate to={`/login?redirect=${location.pathname}`} />} />
          
          {/* Settings Route */}
          <Route 
            path="/settings" 
            element={isAuthenticated && !isExternalUser() ? <Settings /> : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />} 
          />

          {/* Social Media Settings Route */}
          <Route 
            path="/recruitment/social-settings" 
            element={isAuthenticated && !isExternalUser() ? <SocialMediaSettings /> : <Navigate to={isAuthenticated ? "/careers" : `/login?redirect=${location.pathname}`} />} 
          />
          
          {/* Supplier Portal - public, handles own auth */}
          <Route path="/supplier-portal" element={<SupplierPortal />} />

          {/* Counterparty / Supplier Portal - public passwordless OTP auth */}
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal/dashboard" element={<PortalDashboard />} />
          <Route path="/portal/documents/:id" element={<PortalDocumentViewer />} />
          <Route path="/portal/company" element={<PortalCompanyOverview />} />
          <Route path="/portal" element={<Navigate to="/portal/dashboard" replace />} />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to={isAuthenticated ? (isExternalUser() ? "/careers" : getDefaultHomeRoute()) : `/login?redirect=${location.pathname}`} />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;